(() => {
  const macOSRequirement =
    document.querySelector("[data-vmega-macos-requirement]") ||
    Array.from(document.querySelectorAll(".vmega-platforms__grid article small")).find(
      (element) => element.textContent.includes("macOS 12 Monterey")
    );

  if (macOSRequirement) {
    macOSRequirement.textContent =
      "Intel: macOS 10.14 Mojave or later. Apple silicon: macOS 11 Big Sur or later.";
  }

  const updateVariantDisplay = (select) => {
    const commerceRoot = select.closest("[data-vmega-commerce]");
    const selectedOption = select.selectedOptions[0];

    if (!commerceRoot || !selectedOption) return;

    const price = selectedOption.dataset.price || "";
    const comparePrice = selectedOption.dataset.compare || "";
    const isAvailable = selectedOption.dataset.available === "true";

    commerceRoot.querySelectorAll("[data-vmega-price]").forEach((element) => {
      element.textContent = price;
    });

    commerceRoot.querySelectorAll("[data-vmega-compare]").forEach((element) => {
      element.textContent = comparePrice;
      element.hidden = comparePrice === "";
    });

    commerceRoot.querySelectorAll("[data-vmega-submit]").forEach((button) => {
      button.disabled = !isAvailable;
      button.textContent = isAvailable
        ? button.dataset.addLabel || "Add to cart"
        : button.dataset.soldLabel || "Currently unavailable";
    });

    commerceRoot.querySelectorAll("[data-vmega-status]").forEach((status) => {
      status.hidden = isAvailable;
    });
  };

  document.addEventListener("change", (event) => {
    const select = event.target.closest("[data-vmega-variant-select]");
    if (select) updateVariantDisplay(select);
  });

  let demoDownloadActive = false;

  const setDemoProgress = (progress, progressBar, percent) => {
    const value = Math.max(0, Math.min(100, Math.round(percent)));
    progress.setAttribute("aria-valuenow", String(value));
    progressBar.style.width = `${value}%`;
  };

  const downloadDemo = async (button) => {
    if (demoDownloadActive) return;

    const card = button.closest(".vmega-demo-card");
    const label = button.querySelector("[data-vmega-demo-label]");
    const progress = card?.querySelector("[data-vmega-demo-progress]");
    const progressBar = card?.querySelector("[data-vmega-demo-progress-bar]");
    const status = card?.querySelector("[data-vmega-demo-status]");
    const filename = button.dataset.vmegaDemoFilename || "VMEGAfm_Demo";
    const expectedSize = Number(button.dataset.vmegaDemoSize || 0);
    const partUrls = (button.dataset.vmegaDemoParts || "").split("|").filter(Boolean);

    if (!card || !label || !progress || !progressBar || !status || !expectedSize || !partUrls.length) {
      return;
    }

    demoDownloadActive = true;
    const allButtons = Array.from(document.querySelectorAll("[data-vmega-demo-download]"));
    allButtons.forEach((candidate) => {
      candidate.disabled = true;
    });
    button.setAttribute("aria-busy", "true");
    progress.hidden = false;
    setDemoProgress(progress, progressBar, 0);
    label.textContent = "Preparing download";
    status.textContent = "Connecting to the download server…";

    try {
      const fileChunks = [];
      let receivedBytes = 0;

      for (const partUrl of partUrls) {
        const response = await fetch(partUrl, { credentials: "same-origin" });
        if (!response.ok) throw new Error(`Download failed (${response.status})`);

        if (response.body) {
          const reader = response.body.getReader();
          while (true) {
            const { done, value } = await reader.read();
            if (done) break;
            fileChunks.push(value);
            receivedBytes += value.byteLength;
            const percent = (receivedBytes / expectedSize) * 100;
            setDemoProgress(progress, progressBar, percent);
            status.textContent = `Preparing ${Math.min(100, Math.round(percent))}%`;
          }
        } else {
          const part = await response.arrayBuffer();
          fileChunks.push(part);
          receivedBytes += part.byteLength;
          const percent = (receivedBytes / expectedSize) * 100;
          setDemoProgress(progress, progressBar, percent);
          status.textContent = `Preparing ${Math.min(100, Math.round(percent))}%`;
        }
      }

      if (receivedBytes !== expectedSize) {
        throw new Error("The downloaded file size did not match the installer.");
      }

      const installer = new Blob(fileChunks, { type: "application/octet-stream" });
      const downloadUrl = URL.createObjectURL(installer);
      const downloadLink = document.createElement("a");
      downloadLink.href = downloadUrl;
      downloadLink.download = filename;
      downloadLink.hidden = true;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      window.setTimeout(() => URL.revokeObjectURL(downloadUrl), 60000);

      setDemoProgress(progress, progressBar, 100);
      label.textContent = "Download again";
      status.textContent = "Download started — check your Downloads folder.";
    } catch (error) {
      label.textContent = "Try download again";
      status.textContent = "Download interrupted. Please try again.";
      progress.hidden = true;
      setDemoProgress(progress, progressBar, 0);
      console.error("VMEGAfm demo download failed", error);
    } finally {
      demoDownloadActive = false;
      button.removeAttribute("aria-busy");
      allButtons.forEach((candidate) => {
        candidate.disabled = false;
      });
    }
  };

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest("[data-vmega-demo-download]");
    if (button) downloadDemo(button);
  });
})();
